module.exports = __webpack_public_path__ + "img/emptyuser.d672b63b.webp";